import { render, staticRenderFns } from "./home-header.vue?vue&type=template&id=2b5c7501&scoped=true"
import script from "./home-header.vue?vue&type=script&lang=js"
export * from "./home-header.vue?vue&type=script&lang=js"
import style0 from "./home-header.vue?vue&type=style&index=0&id=2b5c7501&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c7501",
  null
  
)

export default component.exports